// components/Review/ReviewTabs.tsx
import Image from 'next/image';
import { Rating } from 'react-simple-star-rating';
import { LoadingSpinner } from '../../shared-components/LoadingSpinner/LoadingSpinner';

interface ReviewTabsProps {
  activeTab: 'website' | 'platform';
  setActiveTab: (tab: 'website' | 'platform') => void;
  externalReviewCount: number;
  externalReviewRating: number;
  websiteReviewCount: number;
  websiteReviewRating: number;
}

const ReviewTabs = ({
  activeTab,
  setActiveTab,
  externalReviewCount,
  externalReviewRating,
  websiteReviewCount,
  websiteReviewRating
}: ReviewTabsProps) => {
  return (
    <div
      className="w-[288px] xsm:w-[340px]  md:w-[70%] xl:w-[40%] 2xl:w-[34%] mx-auto flex justify-between h-[100px] md:h-[120px] mt-1"
      id="reviewTabs"
    >
      <div
        onClick={() => setActiveTab('website')}
        className={`w-[49%] rounded-lg p-1 border px-2 cursor-pointer transition-all ${
          activeTab === 'website' ? 'border-primary shadow-md' : ''
        } bg-[#f7f8fb]`}
      >
        <div className="flex mt-1">
          <Image
            src="/Isolation_Mode.png"
            alt="logo"
            width={50}
            height={50}
            className="object-contain w-[20px] h-[20px] md:w-[24px] md:h-[24px]"
          />
          <p className="text-[14px] md:text-[18px] text-primary font-[700] ml-2">
            SeeSight Tours Website
          </p>
        </div>

        <div className="w-full flex items-center mb-1 md:mt-2">
          <p className="text-[13px] md:text-[15px] text-primary font-[700] mt-[3px] mr-2">
            {websiteReviewRating === 0 ? (
              <LoadingSpinner className="w-3 h-3" />
            ) : (
              `${websiteReviewRating.toFixed(1)}/5`
            )}
          </p>
          <Rating
            initialValue={websiteReviewRating}
            readonly
            iconsCount={5}
            size={16}
            allowHover={false}
            disableFillHover
            fillColor="orange"
            emptyColor="#9B9B9B"
            allowFraction
            SVGstyle={{ display: 'inline-block' }}
          />
        </div>

        <div className="text-[14px] md:text-[18px] text-primary font-[700] -mt-1 md:mt-2 mr-2 flex">
          {websiteReviewCount === 0 ? (
            <LoadingSpinner className="w-3 h-3 mt-1 mr-2" />
          ) : (
            websiteReviewCount
          )}
          <span className="text-[14px] md:text-[17px] font-[500] text-primary ml-1">
            Reviews
          </span>
        </div>
      </div>

      <div
        onClick={() => setActiveTab('platform')}
        className={`w-[49%] rounded-lg p-1 border px-2 cursor-pointer transition-all ${
          activeTab === 'platform' ? 'border-primary shadow-md' : ''
        } bg-[#f7f8fb]`}
      >
        <div className="flex mt-1">
          <div className="flex w-[10%] md:w-[18%]">
            <Image
              src="/Expedia.svg"
              alt="Expedia"
              width={50}
              height={50}
              className="object-cover w-[18px] h-[18px] md:w-[24px] md:h-[24px] rounded-full border border-primary hover:z-[1000]"
            />
            <Image
              src="GetYourGuide.svg"
              alt="GetYourGuide"
              width={50}
              height={50}
              className="object-cover w-[18px] h-[18px] md:w-[24px] md:h-[24px] rounded-full relative right-[15%] border border-primary  hover:z-[1000]"
            />
            <Image
              src="/Tripadvisor.svg"
              alt="Tripadvisor"
              width={50}
              height={50}
              className="object-cover w-[18px] h-[18px] md:w-[24px] md:h-[24px] rounded-full relative right-[30%] border border-primary hover:z-[1000]"
            />
            <Image
              src="Viator.svg"
              alt="Viator"
              width={50}
              height={50}
              className="object-cover w-[18px] h-[18px] md:w-[24px] md:h-[24px] rounded-full relative right-[45%] border border-primary hover:z-[1000]"
            />
            <Image
              src="Google.svg"
              alt="Google"
              width={50}
              height={50}
              className="object-cover w-[18px] h-[18px] md:w-[24px] md:h-[24px] rounded-full relative right-[60%] border border-primary hover:z-[1000]"
            />
            <div className="text-primary relative right-[60%] -mt-[2px] md:mt-[2px]">
              +
            </div>
          </div>

          <p className="text-[14px] md:text-[18px] text-primary font-[700] translate-x-[68%] md:translate-x-[40%] 2xl:translate-x-[31%] xsm:translate-x-[80%] msm:translate-x-[90%] w-[80px] md:w-[150px]">
            Other Platforms
          </p>
        </div>

        <div className="w-full flex items-center mb-1 md:mt-2">
          <p className="text-[13px] md:text-[15px] text-primary font-[700] mt-[3px] mr-2">
            {externalReviewRating === 0 ? (
              <LoadingSpinner className="w-3 h-3" />
            ) : (
              `${externalReviewRating.toFixed(1)}/5`
            )}
          </p>
          <Rating
            initialValue={externalReviewRating}
            readonly
            iconsCount={5}
            size={16}
            allowHover={false}
            disableFillHover
            fillColor="orange"
            emptyColor="#9B9B9B"
            allowFraction
            SVGstyle={{ display: 'inline-block' }}
          />
        </div>

        <div className="text-[14px] md:text-[18px] text-primary font-[700] -mt-1 md:mt-2 mr-2 flex">
          {externalReviewCount === 0 ? (
            <LoadingSpinner className="w-3 h-3 mt-1 mr-2" />
          ) : (
            externalReviewCount
          )}
          <span className="text-[14px] md:text-[17px] font-[500] text-primary ml-1">
            Reviews
          </span>
        </div>
      </div>
    </div>
  );
};

export default ReviewTabs;
